import { FilterOption } from '@/components/Filter/types';
import { UseFilterValuesParams } from '@/components/FilterNew/types';
import useAcademyRelatedConnections from '@/modules/lyearn-connect/hooks/useAcademyRelatedConnections';

import { getAcademyFilterOption } from '../utils';

const EMPTY_ARRAY: never[] = [];

const useAcademyFilterValue = ({ value }: UseFilterValuesParams) => {
  const { connections: connectionsData, fetching } = useAcademyRelatedConnections({
    filters: { workspaceIds: value },
    pause: !value.length,
  });
  const connections = value.length ? connectionsData : EMPTY_ARRAY;

  const selectedOptions: FilterOption[] = connections.map((connection) =>
    getAcademyFilterOption(connection),
  );

  return {
    fetching,
    resolvedValue: connections?.map((dept) => dept.workspaceName),
    selectedOptions,
  };
};

export default useAcademyFilterValue;
